<form (ngSubmit)="saveData()" #addressForm="ngForm">
  <!-- Personal Information Section -->
  <div class="mb-3">
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="name">First Name<span class="text-danger">*</span></label>
          <input id="name" class="form-control" placeholder="Enter your first name" required [(ngModel)]="defaultAddress.name"/>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="lastName">Last Name<span class="text-danger">*</span></label>
          <input id="lastName" class="form-control" placeholder="Enter your last name" required [(ngModel)]="defaultAddress.lastName"/>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="phoneNumber">Phone Number<span class="text-danger">*</span></label>
          <input id="phoneNumber" class="form-control" placeholder="Enter your phone number" required [(ngModel)]="defaultAddress.phoneNumber"/>
        </div>
      </div>
    </div>
  </div>
  <!-- Address Section -->
  <div class="mb-3">
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="line1">Address Line 1<span class="text-danger">*</span></label>
          <input id="line1" class="form-control" placeholder="Enter address line 1" required [(ngModel)]="defaultAddress.line1"/>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="line2">Address Line 2</label>
          <input id="line2" class="form-control" placeholder="Enter address line 2" [(ngModel)]="defaultAddress.line2"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="landmark">Landmark<span class="text-danger">*</span></label>
          <input id="landmark" class="form-control" placeholder="Enter a landmark" required [(ngModel)]="defaultAddress.landmark"/>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="city">City<span class="text-danger">*</span></label>
          <input id="city" class="form-control" placeholder="Enter your city" required [(ngModel)]="defaultAddress.city"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <label for="state" class="form-label">State<span class="text-danger">*</span></label>
        <select id="state" class="form-select" required [(ngModel)]="defaultAddress.state">
          <option value="" disabled selected>Select a state</option>
          <option *ngFor="let state of states" [value]="state.name">{{ state.name }}</option>
        </select>
      </div>
      <div class="col-md-6 mb-3">
        <div class="form-outline">
          <label class="form-label" for="pinCode">Postal Code<span class="text-danger">*</span></label>
          <input id="pinCode" class="form-control" placeholder="Enter your postal code" required [(ngModel)]="defaultAddress.pinCode"/>
        </div>
      </div>
    </div>
  </div>
  <!-- Submit Button -->
  <div class="text-center">
    <button type="submit" class="btn btn-danger btn-sm">Add Address</button>
  </div>
</form>
